@if (myData?.name) {
  <div class="uploaded-document">
    @if (isLoading) {
      <div class="uploaded-document__loading">
        <mat-progress-spinner mode="determinate"
          [value]="myData.uploadProgress"
        diameter="30"></mat-progress-spinner>
      </div>
    }
    @if (!isLoading) {
      <!-- image -->
      @if (myData?.content_type !== 'application/pdf' && myData.content_type !== 'image/heic') {
        <a
          [href]="downloadUrl"
          target="_blank"
          class="uploaded-document__image"
        [style.background-image]="'url(' + downloadUrl  + ')'"></a>
      }
      <!-- heic -->
      @if (myData.content_type === 'image/heic') {
        <a
          [href]="downloadUrl"
          target="_blank"
          class="uploaded-document__image"
        style="background-image: url(/assets/heic-icon.svg);"></a>
      }
      <!-- PDF -->
      @if (myData?.content_type === 'application/pdf') {
        <a
          target="_blank"
          [href]="downloadUrl"
          class="uploaded-document__image"
          style="background-image: url(/assets/pdf-icon.svg);"
        ></a>
      }
    }
    <!-- name -->
    <div class="uploaded-document__name fig-body-2">
      @if (!isLoading) {
        <a [href]="downloadUrl" target="_blank"
        [title]="myData?.name">{{ myData.name }}</a>
      }
      @if (isLoading) {
        <span>{{myData.name}}</span>
      }
    </div>
    <!-- delete button -->
    @if ((!isReadOnly && myData?.attachment_type!=='ID_VERIFICATION_REPORT')) {
      <div class="uploaded-document__button"
        (click)="delete(myData)">
        <img src="/assets/delete-icon.svg" alt="delete" width="16" />
        <span class="fig-caption">Delete</span>
      </div>
    }
  </div>
}
